export default function DisclaimerSection() {
  return (
    <section id="disclaimer" className="relative py-12 md:py-16 bg-warm-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto">
          <div className="bg-midnight/5 rounded-xl p-6 md:p-8 border border-midnight/10">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-8 h-8 rounded-full bg-midnight/10 flex items-center justify-center">
                <i className="ri-shield-check-line text-midnight text-sm" />
              </div>
              <h3 className="font-heading text-lg font-semibold text-midnight">Disclaimer</h3>
            </div>
            <p className="text-taupe-grey text-sm leading-relaxed">
              TNT Coach AI is a personal development and self-coaching tool. It is not therapy, medical advice, financial advice, legal advice, or a substitute for professional support. The app does not represent, imitate, or claim endorsement from any real coach, athlete, author, public figure, or organisation. Coaching styles are original and based on broad personal development principles.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}